// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__2q4kH","loading":"styles_loading__3qQ6M","formShell":"styles_formShell__11o7C"};